import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Importa le pagine
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/Blog/BlogPage";
import PostIoSono from "./pages/Blog/PostIoSono";
import PostNevilleGoddard from "./pages/Blog/PostAlTuoCommando";
import VideoPage from "./pages/VideoPage";
import ContattiPage from "./pages/ContattiPage";

function App() {
  return (
    <Router>
      <div className="App">
        {/* Sezione HERO */}
        <header className="hero">
          <div className="hero-content">
            <img
              src="/logo-circolare.png"
              alt="Frequenze di Saggezza Stoica"
              className="circular-image"
            />
          </div>
        </header>

        {/* Menu di navigazione */}
        <nav className="menu-buttons">
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/blog" className="btn btn-primary">Blog</Link>
          <Link to="/video" className="btn btn-primary">Video</Link>
          <Link to="/contatti" className="btn btn-primary">Contatti</Link>
        </nav>

        {/* Contenuti principali */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/io-sono" element={<PostIoSono />} />
            <Route path="/blog/al-tuo-comando" element={<PostNevilleGoddard />} />
            <Route path="/video" element={<VideoPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="footer">
          <p>&copy; 2025 Frequenze di Saggezza Stoica</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;